import React, { Component } from "react";

import CuentaSocioTransferencia from "../../generico/CuentaSocioTransferencia";
import { trackPromise } from "react-promise-tracker";
import ActividadesEducacionService from "../../../services/pagos/ActividadesEducacionService";
import {FontAwesomeIcon}  from "@fortawesome/react-fontawesome";
import {faArrowLeft, faArrowRight} from "@fortawesome/free-solid-svg-icons";
import TransferCuentasPropiasService from "../../../services/transferencias/TransferCuentasPropiasService";

export default class EducacionPaso2 extends Component {cantEntradass
  constructor(props) {
    super(props);
    this.filterInput = React.createRef();
    this.state = this.getInitialState();
  }

  getInitialState = () => ({
    cuentasOrigen: [],
    cabecera: {},
    itemSelected: { value: "-1", label: "--Seleccione--" },
    cantEntradas: undefined
  });

  resetState = () => {
    this.setState(this.getInitialState());
    this.continuar.disabled = true;
  };

  initData = () => {
    this.resetState();
    this.continuar.disabled = true;
  };
  selectorValue = (dataFromChild, item) => {
    item.tipoDeCuenta=dataFromChild.descripcion;   
    item.moneda=dataFromChild.moneda;  
    this.setState(
      {      
        itemSelected: item,
      },
      this.enableNext
    );
  };

  enableNext() {
    const { itemSelected } = this.state;
    if (itemSelected.value !== undefined && itemSelected.value !== "-1"  && this.state.cantEntradas != undefined
    && this.state.cantEntradas != "" && this.state.cantEntradas != undefined > 0) {
      this.continuar.disabled = false;
    } else {
      this.continuar.disabled = true;
    }
  }
  suscripcionActividadesValida() {
    trackPromise(
      ActividadesEducacionService.suscripcionActividadesValida(
        this.props.actividad[0].actividad
      ).then((response) => {
        var data = JSON.stringify(response.data);
        var jData = JSON.parse(data);
       

        if (jData.codigoRetorno === "0") {

          var _cabecera = {
            fecha: jData.resultados[0].fechaActividad,
            hora: jData.resultados[0].hora,
            ciudad: (jData.resultados[0].ciudad===undefined?"":jData.resultados[0].ciudad),
            lugar: (jData.resultados[0].lugar===undefined?"":jData.resultados[0].lugar),
            costo: jData.resultados[0].costo,
            moneda: jData.resultados[0].moneda,
            importe: jData.resultados[0].costo,
          };

          this.setState({ cabecera: _cabecera });

          TransferCuentasPropiasService.getCuentas("I").then((response) => {
            if (response.data.codigo !== "0" && response.data.mensaje === "SIN RESULTADOS") {
              //Popup.queue(this.notifiPopup("Info", "No posee saldo suficiente en la(s) cuenta(s) de débito para continuar"));
              this.setState({
                mensaje: "No posee saldo suficiente en la(s) cuenta(s) de débito para continuar",
              });
            }
            var data = JSON.stringify(response.data);
            var jsonData = JSON.parse(data);
            this.setState({ cuentasOrigen: jsonData.resultadoAH });
          })

        } else {
          this.setState({
            mensaje: jData.mensaje,
          });
        }
      })
    );
  }

  componentDidMount() {
    this.initData();
  }

  searchNumber = (value) => {

    var refValue =  (this.filterInput.current.value != "" && this.filterInput.current.value != undefined) ? 
                Math. abs(Math.trunc(this.filterInput.current.value)) : "";

    this.setState({ cantEntradas: refValue }, this.enableNext);

  };

  render() {
    return (
      <div>
        <div className="row">
          <div className="steps clearfix">
            <ul role="tablist">
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text current">
                      Selección de Actividades
                    </span>
                  </div>
                </span>
              </li>
              <li role="tab" className="current">
                <span>
                  <div className="title">
                    <span className="title_text current">Datos de Pago</span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text">Datos de Verificación</span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text">Confirmación</span>
                  </div>
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="row justify-content-md-center">
          <div className="col-lg-8 col-md-10">
            <CuentaSocioTransferencia
              selectorValue={this.selectorValue.bind(this)}
              operacion="DEBITO"
              tipoCuenta="AHORRO_VISTA"
              items={this.state.cuentasOrigen}
              itemSelected={this.state.itemSelected}
              isClearable
              noOptionsMessage={() => "SIN DATOS"}
            />
          </div>
        </div>
        <div className="row justify-content-md-center">
          <div className="col-lg-8 col-md-10">
            <label className="input-label-bold">
              Cantidad de entradas a cobrar *
            </label>
            <input
              ref={this.filterInput}
              type="number"
              onChange={(e) => this.searchNumber(e)}
              min="1"
              //onInput="validity.valid||(value='');"
              //onkeyup="this.value= Math.trunc(this.value)"
              placeholder="Ingrese cantidad de entradas"
              className="input-box form-control"
              value={this.state.cantEntradas}
            />
            {/* <span style={{ fontSize: "small", color: "#adadad" }}>
              Cantidad de Entradas de 1 a {this.state.nroCuotas}
            </span> */}
            <div className="form-validate" style={{ paddingLeft: 0, paddingTop: 0 }}>
            </div>
          </div>
        </div>

        <hr />
        <div className="row">
          <div className="col-lg-8 col-md-6">
          <label className="input-label-bold-obligatorio">
                (*) Campos Obligatorios
              </label>
          </div>
          <div className="col-lg-2 col-md-3 btn-consulta">
          <button
              className="btn btn-cu-quintary"
              onClick={this.props.previousStep}
            >
            <FontAwesomeIcon icon={faArrowLeft} />  Volver
            </button>
            <button
              hidden
              ref={(a) => (this.nextStep = a)}
              className="btn btn-cu-primary"
              onClick={this.props.nextStep}
            />
          </div>
          <div className="col-lg-2 col-md-3">
          <button
              ref={(button) => (this.continuar = button)}
              disabled={this.state.disableSgte}
              className="btn btn-cu-primary"
              onClick={() => {
                var returnData =this.state.itemSelected;
                returnData.cabecera = this.state.cabecera;
                this.props.returnDataPaso2(returnData, this.state.cantEntradas);
                this.nextStep.click();
              }}
            >
              Continuar <FontAwesomeIcon icon={faArrowRight} />
            </button>
          </div>
        </div>

      </div>
    );
  }
}
